// src/api/supportApi.ts
import baseGoApi from './baseGoApi';
import { SupportTicket, SupportResponse, TicketSummary, TicketDetail } from '../types/SupportTicket';

export const createSupportTicket = async (ticket: SupportTicket): Promise<SupportResponse> => {
    try {
        const response = await baseGoApi.post<SupportResponse>('/support/tickets', ticket);
        return response.data;
    } catch (error) {
        console.error('Error creating support ticket:', error);
        throw error;
    }
};

export const listSupportTickets = async (filter: 'ongoing' | 'closed' = 'ongoing'): Promise<TicketSummary[]> => {
    try {
        const response = await baseGoApi.get<{ tickets: TicketSummary[] }>('/support/tickets', {
            params: { filter },
        });
        return response.data.tickets;
    } catch (error) {
        console.error('Error listing support tickets:', error);
        throw error;
    }
};

export const getSupportTicket = async (ticketId: string): Promise<TicketDetail> => {
    try {
        const response = await baseGoApi.get<TicketDetail>(`/support/tickets/${ticketId}`);
        return response.data;
    } catch (error) {
        console.error('Error getting support ticket:', error);
        throw error;
    }
};

export const replyToSupportTicket = async (ticketId: string, body: string): Promise<void> => {
    try {
        await baseGoApi.post(`/support/tickets/${ticketId}/reply`, { body });
    } catch (error) {
        console.error('Error replying to support ticket:', error);
        throw error;
    }
};
